import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

export interface ClientErrorScreenMessage {
	title: string;
	description: string;
	date?: string;
}

export const DEFAULT_MESSAGE: ClientErrorScreenMessage = {
	title: 'Something went wrong',
	description: "We couldn't complete that request. Please try again in a moment.",
};

@Injectable({ providedIn: 'root' })
export class ClientErrorScreenService {
	private readonly router = inject(Router);

	private readonly message$$ = new BehaviorSubject(DEFAULT_MESSAGE);
	public readonly message$ = this.message$$.asObservable();

	private _somethingFailed = false;

	public get somethingFailed(): boolean {
		return this._somethingFailed;
	}

	public async show(message: ClientErrorScreenMessage): Promise<void> {
		this._somethingFailed = true;
		this.message$$.next({
			...message,
			date: message.date ?? new Date().toISOString(),
		});
		await this.router.navigate(['/', 'client-error'], {
			onSameUrlNavigation: 'reload',
		});
	}
}
